// extracted by mini-css-extract-plugin
export var body = "SideBySide-module--body--c2312";
export var img = "SideBySide-module--img--be817";
export var media = "SideBySide-module--media--813b6";
export var right = "SideBySide-module--right--68eed";
export var root = "SideBySide-module--root--5e6af";